import { simpleSmartAccount } from './simple/client';
import { modularSmartAccount } from './modular/client';
import { ethersSignerToAccount } from '../utils/ethersSignerToAccount';
import { getChain } from '../utils/getChain';
import { determineSmartAccount } from './determineSmartAccount';
import { createPublicClient, http } from 'viem';
export const setupSmartAccount = async (args) => {
    const { newAccountImplementationType, signer, rpcUrl, bundlerUrl, paymasterProxyUrl, paymasterProxyAuthSecret, spaceDapp, fetchAccessTokenFn, forceSmartAccountAddress, forceSmartAccountType, usePimlicoPaymaster, enableUsdc, } = args;
    const owner = await ethersSignerToAccount(signer);
    const chain = await getChain(signer);
    if (forceSmartAccountAddress && !forceSmartAccountType) {
        throw new Error('setupSmartAccount: forceSmartAccountType is required when forceSmartAccountAddress is provided');
    }
    const publicRpcClient = createPublicClient({
        transport: http(args.rpcUrl),
        chain,
    });
    if (forceSmartAccountAddress) {
        if (forceSmartAccountType === 'simple') {
            return simpleSmartAccount({
                publicRpcClient,
                owner,
                rpcUrl,
                chain,
                address: forceSmartAccountAddress,
                bundlerUrl,
                paymasterProxyUrl,
                paymasterProxyAuthSecret,
                spaceDapp,
                fetchAccessTokenFn,
                usePimlicoPaymaster,
            });
        }
        if (forceSmartAccountType === 'modular') {
            return modularSmartAccount({
                publicRpcClient,
                owner,
                rpcUrl,
                chain,
                address: forceSmartAccountAddress,
                bundlerUrl,
                paymasterProxyUrl,
                paymasterProxyAuthSecret,
                spaceDapp,
                fetchAccessTokenFn,
                usePimlicoPaymaster,
                enableUsdc,
            });
        }
        throw new Error(`setupSmartAccount: unsupported forceSmartAccountType: ${forceSmartAccountType}`);
    }
    const { address, accountType } = await determineSmartAccount({
        ownerAddress: owner.address,
        newAccountImplementationType,
        paymasterProxyUrl,
        paymasterProxyAuthSecret,
    });
    const _accountType = forceSmartAccountType ?? accountType;
    if (_accountType === 'modular') {
        return modularSmartAccount({
            publicRpcClient,
            owner,
            rpcUrl,
            chain,
            address,
            bundlerUrl,
            paymasterProxyUrl,
            paymasterProxyAuthSecret,
            spaceDapp,
            usePimlicoPaymaster,
            fetchAccessTokenFn,
            enableUsdc,
        });
    }
    if (accountType === 'simple') {
        return simpleSmartAccount({
            publicRpcClient,
            owner,
            rpcUrl,
            chain,
            address,
            bundlerUrl,
            paymasterProxyUrl,
            paymasterProxyAuthSecret,
            spaceDapp,
            usePimlicoPaymaster,
            fetchAccessTokenFn,
        });
    }
    throw new Error(`Unsupported account type`);
};
